import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import SEO from 'Components/SEO/SEO';

const getAddressComponent = type => components => components.find(component => component.type === type);
const getCity = getAddressComponent('CITY');
const getState = getAddressComponent('STATE');

const ItemSEO = ({
    item,
    category,
    location
}) => {
    const appendLocationAndCategory = useCallback(components => {
        const addressComponents = location && location.addressComponents || [];

        const city = getCity(addressComponents);
        const state = getState(addressComponents);

        if (city && city.name) {
            components.push(city.name);
        }

        if (category && category.name) {
            components.push(category.name);
        }

        if (state && state.name) {
            components.push(state.name);
        }

        return components.join(' - ');
    }, [category, location]);

    const appendId = useCallback((components = []) => {
        if (item && item.id) {
            components.push(item.id);
        }

        return components.join(' - ');
    }, [item]);

    const title = useMemo(() => appendId([appendLocationAndCategory([item.title])]), [appendId, appendLocationAndCategory, item.title]);

    const description = useMemo(() => appendLocationAndCategory([item.description]), [appendLocationAndCategory, item.description]);

    return (
        <SEO
            page="item"
            title={ title }
            description={ description }
        />
    );
};

ItemSEO.propTypes = {
    category: PropTypes.object,
    item: PropTypes.object,
    location: PropTypes.object
};

export default ItemSEO;
